import FormFieldGenerator from "./FormFieldGenerator";
import HelpWidget from "./HelpWidget";
import JSDisplayArrayOfObjects from "./JSDisplayArrayOfObjects";
// import Komentar from "./Komentar";


// FormCsvEditorWidget

// TODO csvColumnsError


// DEFAULT COMPONENT
const FormCsvEditorWidget = (props) => {
  const {
    csvEditorWidgetPack
  } = props;
  const {
    csvInputVal, handleCsvInputChange, csvInputError, setCsvInputVal, csvSeparator, setCsvSeparator, arrayOfObjectsFromCsv
  } = csvEditorWidgetPack;
  //
  //
  return (
    <>
      <div className="csv-editor-widget">
        <div className="card-export-read-only-form csv-editor-widget__card">
          <div className="vector gaps column">
            <div className="xi">
              <HelpWidget>
                <p>Morate uneti ispravan CSV.</p>
                <p>- Prvi red CSV podataka mora da bude ne podaci nego <b>Nazivi kolona</b>. <br />Svi ostali redovi se tumače na osnovu prvog reda. <br />Redosled je po vašem izboru i biće tumačen na osnovu prvog reda.</p>
                <p>- Nazivi kolona u prvom redu moraju biti jedinstveni.</p>
                <p>- Separator (razdvajač kolona) možete izabrati "," ili ";" (zarez ili tačka-zarez). Takodje može i "TAB" (nevidljivi character) ako je u pitanju TSV.<br />Posle poslednje kolone ne treba separator.</p>
                <p>- Na kraju, proverite ispod, da li su protumačeno podaci iz CSV-a kao što ste želeli.</p>
              </HelpWidget>
              <div className="uu-text-nowrap">
                <FormFieldGenerator
                  fieldDefinition={{
                    "type": "input_radio_group",
                    "params": {
                      "label": "CSV separator/delimeter , ili ;",
                      "name": "csvSeparator",
                      "options": [
                        { "title": ", (zarez)", "value": "," },
                        { "title": "; (tačka-zarez)", "value": ";" },
                        { "title": "Tab-separated values (TSV) - na primer copy/paste iz Excel-a", "value": "_TAB_CHARACTER_" },
                      ]
                    }
                  }}
                  value={csvSeparator}
                  formErrors={{}}
                  handleChange={(e) => { setCsvSeparator(e.target.value) }}
                />
                <FormFieldGenerator
                  fieldDefinition={{
                    "type": "textarea",
                    "params": {
                      "label": "CSV",
                      "name": "csvInputVal",
                      // "w": 480,
                      // "h": 96,
                    }
                  }}
                  value={csvInputVal}
                  formErrors={{ "csvInputVal": csvInputError }}
                  handleChange={handleCsvInputChange}

                  className="textarea-custom-popuni-putem-json"
                />
              </div>
              <div>
                <div><b>Protumačeni tabelarni podaci iz CSV:</b></div>
                <div className="uu-text-whitespace-pre">
                  <JSDisplayArrayOfObjects val={arrayOfObjectsFromCsv} extra />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCsvEditorWidget;